export { SearchTermType } from 'src/app/shared/enums/typeahead';

export enum SearchTermName {
  Term = 'Open Search',
  Artist = 'Artist',
  Writer = 'Writer',
  Title = 'Title',
  Album = 'Album',
  Lyrics = 'Lyrics',
  ISRC = 'ISRC',
  SONG_CODE = 'Song Code',
  KEYWORD = 'Keyword',
  EXTERNAL_LINK = 'Similar songs',
  PROMPT = 'Description',
}

export enum SearchTermPluralName {
  Term = 'Recordings, Artists, Writers, Lyrics and more...',
  WorkTerm = 'Titles, Creators, and Lyrics',
  Artist = 'Artists',
  Writer = 'Writers',
  Title = 'Titles',
  Album = 'Albums',
  Lyrics = 'Lyrics',
  ISRC = 'Recordings, Artists, Writers, Lyrics and more...',
  SONG_CODE = 'Recordings, Artists, Writers, Lyrics and more...',
  KEYWORD = 'for keywords in songs, lyrics, band names, and more',
  EXTERNAL_LINK = 'Paste external link from Youtube, Spotify, and more',
  PROMPT = 'Describe the song, such as angsty emo band from the 90s',
}

export enum SearchTermsContentType {
  Query = 'queries',
  Tag = 'tags',
  ExternalLink = 'queries',
  Prompt = 'queries',
}
